import { useTranslation } from "react-i18next";
import { cn } from "@jbnl/shared-ui";

/**
 * Both states are drawn: an absent badge reads as a screen still loading. Blue and muted rather
 * than green and red - a closed window is a fact about the calendar, not a fault (ADR-0025).
 */
export function VensterBadge({ open }: { open: boolean }) {
  const { t } = useTranslation("inschrijfperiodes");

  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center rounded-full px-2 py-0.5 text-xs font-bold",
        open
          ? "bg-secondary-surface text-secondary-active"
          : "bg-muted text-muted-foreground",
      )}
    >
      {open ? t("venster.badgeOpen") : t("venster.badgeGesloten")}
    </span>
  );
}
